import { Party } from '@scts/models';
import AddressComponent from './address';
import Basic from './basic';
import OnBehalf from './on-behalf';

export interface AppointeeProps {
  appointee: Party;
  client: Party;
}

const Appointee = (appointeeProps: AppointeeProps) => {
  return (
    <>
      <OnBehalf onBehalf={appointeeProps.client} />
      <Basic basicDetails={appointeeProps.appointee} />
      <AddressComponent address={appointeeProps.appointee.address} />
    </>
  );
};

export default Appointee;
